export const SET_LATEST_PRIVACY_POLICY = (state, payload) =>
  (state.latest_privacy_policy = payload);

// export const SET_LATEST_PRIVACY_POLICY_TO_ACCEPT = (state, payload) =>
//   (state.latest_privacy_policy_to_accept = payload);
